export class MandatOrigine {

    mdo_id: string;
    mdo_code: string;
    mdo_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.mdo_id                     = data['mdo_id'] ? data['mdo_id'] : null;
        this.mdo_code                   = data['mdo_code'] ? data['mdo_code'] : null;
        this.mdo_libelle                = data['mdo_libelle'] ? data['mdo_libelle'] : null;
    }

}
